package es.cinfo.tiivii.user.splash.usecase

internal actual val PLATFORM_CLIENT_ID = "default-web"
internal actual val PLATFORM_CLIENT_ID_SUFFIX = "-web"